import {getConfidenceColor} from './mapping';
import {roundNumber} from '../../helpers/dataHelper';

export function getDashboardTooltip(name, data) {
    switch (name) {
        case 'text':
            return contextAsText(data);
        case 'instantText':
            return contextAsInstantText(data);
        case 'filtersBlockFilterTooltip':
            return filtersBlockFilterTooltip(data);
        case 'appTooltip':
            return appTooltip(data);
        case 'importBoard':
            return importBoard(data);
        case 'boardMenuTooltip':
            return boardMenuTooltip(data);
        case 'subscriptionTooltip':
            return subscriptionTooltip(data);
        case 'predictionTooltip':
            return predictionTooltip(data);
        case 'subscriptionTooltipPayingUsers':
            return subscriptionTooltipPayingUsers(data);
        default:
    }
}

function filtersBlockFilterTooltip(currentFilter) {
    return {
        title: currentFilter.type,
        content: currentFilter.filters.join('<br>'),
    };
}

function importBoard() {
    return {
        title: '',
        content: 'Import to my Dashboard',
        direction: 'right',
    };
}

function boardMenuTooltip(text) {
    return {
        title: '',
        content: text,
        showDelay: 500,
        offsets: {
            top: -30,
            left: 0,
        },
    };
}

function subscriptionTooltip(dataObj) {
    const subscriptions = dataObj.data;
    const defaultOffsets = {
        top: 0,
        left: 0,
    };
    const offsets = Object.assign({}, defaultOffsets, dataObj.offsets);
    const content = subscriptions ? subscriptions.reduce((line, subscription) => {
        return `${line}<div style="display: flex;justify-content: space-between"><span>${subscription.product_id}</span><span style="padding-left: 15px">${subscription.count}</span></div>`;
    }, '') : '';
    return {
        title: '',
        content,
        showDelay: 500,
        offsets,
    };
}

function predictionTooltip(dataObj) {
    const board = dataObj.data.board;
    const predictType = dataObj.data.predictType;
    const prediction = board.predictions;
    const refPecent = board.refundPercent ? (100 - board.refundPercent) / 100 : 1;
    const defaultOffsets = {
        top: 0,
        left: 0,
    };
    let content = '<table class="predict-tooltip">';
    content += '<tr><td>product</td><td>rev.</td><td>ppa</td><td>act.</td><td>arppu.</td><td>conf.</td></tr>';
    if (prediction[`products${predictType}`]) {
        prediction[`products${predictType}`].forEach((product) => {
            content += '<tr>';
            const confidencePerc = product.confidence * 10;
            const color = getConfidenceColor(product.confidence);
            content += `<td>${product.product_id} </td>`;
            content += `<td>$${roundNumber(product.ltv * refPecent)} </td>`;
            content += `<td>${roundNumber(product.ppa)} </td>`;
            content += `<td>${roundNumber(product.product_size)}</td>`;
            content += `<td>$${roundNumber((product.ltv / product.product_size) * refPecent) || 0}</td>`;
            content += `<td><div class="progress-vertical progress-vertical_${color}">
                    <div style="height:${confidencePerc}%"></div>
                </div></td>`;
            content += '</tr>';

        });
        content += '</table>';
    }
    const offsets = Object.assign({}, defaultOffsets, dataObj.offsets);
    return {
        title: '',
        content,
        showDelay: 500,
        offsets,
    };
}

function subscriptionTooltipPayingUsers(dataObj) {
    const subscriptions = dataObj.data ? dataObj.data.filter((sub) => sub.discount_type !== 'trial') : '';
    const defaultOffsets = {
        top: 0,
        left: 0,
    };
    const offsets = Object.assign({}, defaultOffsets, dataObj.offsets);
    const content = subscriptions ? subscriptions.reduce((line, subscription) => {
        return `${line}<div style="display: flex;justify-content: space-between"><span>${subscription.product_id}</span><span style="padding-left: 15px">${subscription.count}</span></div>`;
    }, '') : '';
    return {
        title: '',
        content,
        showDelay: 500,
        offsets,
    };
}

function appTooltip(app) {
    const appLink = app.url ? app.url :  app.os !== 'ios' ? `https://play.google.com/store/apps/details?id=${app.bundle_id }`: '/';
    const content = `Title: ${app.title}<br>
    Bundle: ${app.bundle_id}<br>
    ${app.os === 'ios' ? 'AppStore' : 'GooglePlay '} link: <a href="${appLink}" target="_blank" style=" display: inline-block;
    vertical-align: middle;">
    <img style="height: 17px;" src="icons/app/icon_external-link.svg" alt=""></a> <br>`;

    return {
        title: '',
        content,
        clickable: true,
        offsets: {
            top: -30,
            left: 0,
        },
    };
}

function contextAsText(text) {
    return {
        title: '',
        content: text,
    };
}

function contextAsInstantText(text) {
    return {
        title: '',
        content: text,
        showDelay: 0,
    };
}
